"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportFormatEnum = void 0;
var ExportFormatEnum;
(function (ExportFormatEnum) {
    ExportFormatEnum["CSV"] = "csv";
    ExportFormatEnum["CSV_LEXWARE"] = "csv_lexware";
    ExportFormatEnum["DATEV"] = "datev";
    ExportFormatEnum["DATEV_ONLINE"] = "datev_online";
    ExportFormatEnum["DATEV_INVOICE_CSV"] = "datev_invoice_csv";
    ExportFormatEnum["DATEV_WALLET_CSV"] = "datev_wallet_csv";
    ExportFormatEnum["INVOICES"] = "invoices";
    ExportFormatEnum["SEPA"] = "sepa";
    ExportFormatEnum["NON_SEPA"] = "non_sepa";
    ExportFormatEnum["ALL"] = "all";
    ExportFormatEnum["MARK_AS_DONE"] = "mark_as_done";
    ExportFormatEnum["AUDIT_TRAIL"] = "audit_trail";
    ExportFormatEnum["CHANGE_HISTORY"] = "change_history";
})(ExportFormatEnum || (exports.ExportFormatEnum = ExportFormatEnum = {}));
